import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { buttonVariants, type ButtonProps } from './variants';

/**
 * Generic button component with design-system variants.
 *
 * @example
 * ```tsx
 * <Button variant="default" size="md">Trending</Button>
 * <Button variant="outline">39% Yes</Button>
 * <Button variant="success">Buy Up</Button>
 * <Button variant="danger">Buy Down</Button>
 * ```
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ className, variant, size, ...props }, ref) => (
  <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />
));
Button.displayName = 'Button';

export { Button };
